import { render } from "./EstadoPneu.vue?vue&type=template&id=2250ea4d&scoped=true"
import script from "./EstadoPneu.vue?vue&type=script&lang=js"
export * from "./EstadoPneu.vue?vue&type=script&lang=js"

import "./EstadoPneu.vue?vue&type=style&index=0&id=2250ea4d&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2250ea4d"]])

export default __exports__